import React from "react"
import { Button } from "reactstrap"
import { RiArrowRightDoubleLine } from "react-icons/ri"
import { useNavigate } from "react-router-dom"

const DoubleArrowButton = ({ name, navigationLink = "#" }) => {

  const navigate = useNavigate()

  return (
    <Button
      color="info"
      style={{
        backgroundColor: "#48b9e2 !important",
        borderColor: "#48b9e2 !important",
      }}
      className="mt-3 d-flex align-items-center justify-content-between fw-medium"
      onClick={() => navigate(navigationLink)}
    >
      {name}
      <span>
        <RiArrowRightDoubleLine size={32} />
      </span>
    </Button>
  )
}

export default DoubleArrowButton
